
/* An object containing 'special' Magento Configurable Attributes, which should be displayed in a
  different manner to how they are configured. It is keyed by attribute code, and each value is
  the 'type' to set on the attribute. */
export const SPECIAL_ATTRIBUTE_TYPES = {
  card_quantity: 'select',
  envelope_addressing: 'select',
};



// WEBPACK FOOTER //
// ./src/constants/attributes.js